var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steptwo"},[_c('ContactTypeSelect'),_c('ContactForm',{ref:"contactdata"}),_c('vca-arrow-navigation',{attrs:{"backLabel":this.$t('buttons.back'),"nextLabel":this.$t('buttons.next'),"nextEnabled":_vm.isValid},on:{"next":_vm.submit,"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }